import React from "react";

function Freedemo() {
  return <div>Freedemo</div>;
}

export default Freedemo;
